import { FC, ReactNode } from "react";

import { Typography } from "@digital-services/ui";

interface Props {
  baseKey: string;
  baseValue: string | ReactNode;
}

export const BasicKeyValuePair: FC<Props> = props => {
  const { baseKey, baseValue } = props;

  return (
    <>
      <Typography className="self-center">{baseKey}</Typography>
      <div className="flex justify-start gap-2">
        <Typography className="self-center font-bold">{baseValue}</Typography>
      </div>
    </>
  );
};
